<div class="ctl-search-area">
    <div class="content" *ngIf="gridControlsList$ | async as gridControlsListItem">
        <div class="birim-secim-area" *ngIf="!isGelenBelge && !isOnlyGrid">
    
            <dx-button stylingMode="contained" [ngClass]="selectedBirimTuru==='I'?'green-color':''" text="İç Birimler" type="default" [width]="110" [icon]="'description'"
            (onClick)="selectedTur('I')" *ngIf="isShowIcBirimler">
          </dx-button>
          <dx-button stylingMode="contained" [ngClass]="selectedBirimTuru==='R'?'green-color':''" text="Dış Birimler" type="default" [width]="110" [icon]="'description'"
            (onClick)="selectedTur('R')">
          </dx-button>
          <dx-button stylingMode="contained" [ngClass]="selectedBirimTuru==='K'?'green-color':''" text="Gerçek Kişiler" type="default" [width]="110" [icon]="'user'"
            (onClick)="selectedTur('K')">
          </dx-button>
          <dx-button stylingMode="contained" [ngClass]="selectedBirimTuru==='T'?'green-color':''" text="Tüzel Kişiler" type="default" [width]="110" [icon]="'box'"
            (onClick)="selectedTur('T')">
          </dx-button>
          <dx-button stylingMode="contained" *ngIf="!notInIcBirimler" [ngClass]="selectedBirimTuru==='A'?'green-color':''" text="Tümü" type="default" [width]="110" [icon]="'columnchooser'"
            (onClick)="selectedTur('A')">
          </dx-button>
          <dx-button stylingMode="contained" *ngIf="notInIcBirimler"  [ngClass]="selectedBirimTuru==='NI'?'green-color':''" text="Tümü" type="default" [width]="110" [icon]="'columnchooser'"
            (onClick)="selectedTur('NI')">
          </dx-button>
        </div>
        <div class="first-table-container">
        <dk-dx-data-table2
        class="px-7"
        [dataSource]="data"
        [columnList]="columns"
        height="100%"
        [gridCtlList]="gridControlsListItem"
        [columnTransactions]="false"
        (focusedRowChanged)="focusChanged($event)"
        [dontSelectDataSource]="true"
        [isGroupingYn]="false"
        [focusSearchBar]="true"
        (keyDown)="onKeyDown($event)"
        (rowDblClick)="dblClickRow($event)"
        >
        </dk-dx-data-table2>
        </div>
    </div>
        
        <div class="search-btn-area">
            <div>
                <dx-button
                    icon="check"
                    stylingMode="contained"
                    text="Seç"
                    type="success"
                    [width]="150"
                    (onClick)="chooseBtnClick()">
                </dx-button>
            </div>
            <div class="search-right-btn">
                <dx-button
                    icon="close"
                    stylingMode="contained"
                    text="İptal"
                    type="danger"
                    [width]="150"
                    (onClick)="cancelBtnClick()">
                </dx-button>
            </div>
        </div>
    </div>

    <dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage" [displayTime]="3000">
    </dx-toast>